import { useNavigate } from 'react-router-dom';
import { UserHeaderProfileMenu } from '@/components/ui/UserHeaderProfileMenu';

const USER_AREA_HEADER_LOGO =
	'https://res.cloudinary.com/dd5pbp2tb/image/upload/v1770986600/Plumaa_H_W_hribid.png';

const UserAreaHeader = () => {
	const navigate = useNavigate();

	return (
		<header className="relative z-50 flex h-16 items-center justify-between bg-stone-900 px-4">
			<button
				type="button"
				onClick={() => navigate('/home')}
				className="rounded-md transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
				aria-label="Ir para a home"
			>
				<img
					src={USER_AREA_HEADER_LOGO}
					className="h-10 w-auto object-contain"
					alt="Logotipo Plumaa"
				/>
			</button>

			<UserHeaderProfileMenu />
		</header>
	);
};

export { UserAreaHeader };
